var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill-rule":"evenodd","aria-hidden":"true","d":"M3.625 5.33l-3.5-4A.5.5 0 0 1 .5.5h7a.5.5 0 0 1 .376.83l-3.5 4a.5.5 0 0 1-.752 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }